import React from 'react';
import { Box, Button, Typography } from "@mui/material";
import ReactQuill from "react-quill";
import { ReactQuillsProps, removeHtmlTagsAndEntities } from "../../../../utils";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomButton } from '../../../Button/Button';

const MilestoneDescription = ({ 
  description, 
  setDescription, 
  handleDescription,
  setShowEditor 
}) => {
  const isMobile = useResponsive("down", "md");

  return (
    <Box className="left-side-milestone">
      <Typography className="milestone-lable">
        Description<span className="star">*</span>
      </Typography>

      <Box>
        <ReactQuill
          value={description}
          modules={ReactQuillsProps.modules}
          formats={ReactQuillsProps.formats}
          className="react-quill-description"
          onChange={(value) =>
            removeHtmlTagsAndEntities(value).length === 0
              ? setDescription("")
              : setDescription(value)
          }
          style={{ height: isMobile ? "170px" : "438px" }}
        />
        <div className="edit-milestone-text-editor-btn-div d-flex">
          <CustomButton
            onClick={handleDescription}
            className="text-editor-btn1"
            variant="contained"
          >
            <div className="text-editor-btn-content">Save</div>
          </CustomButton>
          <CustomButton
            onClick={() => setShowEditor(false)}
            className="text-editor-btn2"
            variant="outlined"
          >
            <div className="text-editor-btn-content">Cancel</div>
          </CustomButton>
        </div>
      </Box>
    </Box>
  );
};

export default MilestoneDescription; 